// extracted by mini-css-extract-plugin
export default {"root":"Editor_root__BVWiL","textArea":"Editor_textArea__Ahgas","control":"Editor_control__AABti","controlButton":"Editor_controlButton__QeSRl"};